function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Caminho_4417",
  "data-name": "Caminho 4417",
  d: "M59.713,1013.188a2.679,2.679,0,0,0-.761-5.254,2.71,2.71,0,0,0-2.7,2.71,2.639,2.639,0,0,0,1.943,2.54,4.355,4.355,0,0,0-3.474,4.113c0,2.337,8.471,2.337,8.471,0A4.351,4.351,0,0,0,59.713,1013.188Z",
  transform: "translate(-54.716 -1007.934)"
});

var SvgContactIcon = function SvgContactIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.471,
    height: 11.116,
    viewBox: "0 0 8.471 11.116",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgContactIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contact-icon.039b1d14.svg";
export { ForwardRef as ReactComponent };